import { useQuery } from '@tanstack/react-query';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { CircleCheckBig } from 'lucide-react';

import { fetchSessionStatus } from '@/entities/payment/api';

import { ErrorFallback } from '@/shared/components/error-fallback';
import { RingSpinner } from '@/shared/components/loader/ring-spinner';
import { Button } from '@/shared/components/shadcn/button';
import { Stage } from '@/shared/components/stage/stage';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

export function CheckoutReturnPage() {
  const { session_id } = useSearch({ from: '/checkout/return' });
  const { workspaceId } = useWorkspaceId();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['session-status', session_id],
    queryFn: () => fetchSessionStatus(session_id),
  });

  return (
    <Stage className="flex h-140 flex-col items-center justify-center">
      <Stage.Scene status={isLoading}>
        <RingSpinner />
      </Stage.Scene>
      <Stage.Scene status={data?.status === 'failed'}>
        <ErrorFallback
          error={new Error('Checkout failed')}
          reset={() => {
            navigate({
              to: '/workspace/$workspaceId/settings/plan',
              params: { workspaceId: workspaceId },
            });
          }}
          title="Something went wrong"
          description="Please try again later."
        />
      </Stage.Scene>
      <Stage.Scene status={data}>
        {(data) => (
          <div className="flex max-w-200 flex-1 flex-col items-center justify-center gap-8">
            <CircleCheckBig className="size-16 text-green-500" />
            <h1 className="text-center text-4xl font-bold">Checkout complete</h1>
            <Button
              size="lg"
              onClick={() => {
                navigate({
                  to: '/workspace/$workspaceId',
                  params: { workspaceId: data.workspace_id },
                });
              }}
            >
              Continue
            </Button>
          </div>
        )}
      </Stage.Scene>
      <Stage.Scene default>
        <ErrorFallback
          error={new Error('Checkout failed')}
          reset={() => {
            navigate({
              to: '/workspace/$workspaceId/settings/plan',
              params: { workspaceId: workspaceId },
            });
          }}
          title="Something went wrong"
          description="Please try again later."
        />
      </Stage.Scene>
    </Stage>
  );
}
